import React from 'react';

const UpgradeNudgeTaskLimitLow50Percent = () => (
  <svg fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <g filter="url(#filter0_d)">
        <path
          d="M0 75C0 69.4772 4.47715 65 10 65H414C419.523 65 424 69.4772 424 75V205C424 210.523 419.523 215 414 215H10C4.47715 215 0 210.523 0 205V75Z"
          fill="white"
        />
      </g>
      <rect
        fill="#F2F2F2"
        height="20"
        rx="10"
        transform="matrix(1 0 0 -1 30 165)"
        width="325"
      />
      <rect
        fill="#F2F2F2"
        height="15"
        rx="2"
        transform="matrix(1 0 0 -1 30 130)"
        width="130"
      />
    </g>
    <rect
      fill="#FFC43E"
      height="20"
      rx="10"
      transform="matrix(1 0 0 -1 29 165)"
      width="163"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="170"
        id="filter0_d"
        width="444"
        x="-10"
        y="60"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect fill="white" height="280" width="385" />
      </clipPath>
    </defs>
  </svg>
);

export default UpgradeNudgeTaskLimitLow50Percent;
